import React, { useEffect, useState } from "react";
import MainHeader from "./MainHeader";
import Sidebar from "./Sidebar";
import { SlMagnifier } from "react-icons/sl";
import axios from "axios";
import { FaCircle } from "react-icons/fa";


const Inventory = () => {
  const [error, setError] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [openAccordion, setOpenAccordion] = useState(null); // Track the open accordion
  const [resourceData, setResourceData] = useState([]);
  const [selectedGroupName, setSelectedGroupName] = useState("");
  const [searchTerm, setSearchTerm] = useState('');

  const groupedResources = resourceData
  .filter((value, index, self) =>
    index === self.findIndex((t) => t.resourceGroup === value.resourceGroup)
  )
  .filter((group) => {
    // Safely handle when resourceGroupTags is null, undefined, or empty
    const tags = group?.resourceGroupTags || {};

    const nameMatches = Array.isArray(tags.Name)
      ? tags.Name.some((name) => name?.toLowerCase().includes(searchTerm?.toLowerCase()))
      : tags.Name?.toLowerCase()?.includes(searchTerm?.toLowerCase());

    const costcenterMatches = Array.isArray(tags.costcenter)
      ? tags.costcenter.some((costcenter) =>
          costcenter?.toLowerCase().includes(searchTerm?.toLowerCase())
        )
      : tags.costcenter?.toLowerCase()?.includes(searchTerm?.toLowerCase());

    // If resourceGroupTags is empty, include the group
    return nameMatches || costcenterMatches || Object.keys(tags).length === 0;
  });


  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const handleSidebarToggle = (isOpen) => {
    setIsSidebarOpen(isOpen);
  };
  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/cloud/azure/resources`);
        const updatedData = response.data.data.data.map((item) => ({
          ...item,
          state:
            item.state === "PowerState/deallocated"
              ? "Stopped"
              : item.state === "PowerState/running"
                ? "Running"
                : item.state,
        }));
        setResourceData(updatedData)
      } catch (err) {
        console.error("Error fetching data:", err.response || err.message);
        setError("Failed to fetch data.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const sortedResources = (resources) => {
    if (!sortConfig.key) return resources;
    return resources.sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === "asc" ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === "asc" ? 1 : -1;
      }
      return 0;
    });
  };

  const toggleAccordion = (index, name) => {
    setOpenAccordion(openAccordion === index ? null : index); // Toggle accordion open/close
    setSelectedGroupName(name);
  };

  if (error) return <div>{error}</div>;

  const filterDataByName = resourceData.filter(item => item?.resourceGroup === selectedGroupName);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

  }

  return (
    <div>
      <Sidebar onToggle={handleSidebarToggle} />
      <div
        className={`content p-5 ${
          isSidebarOpen ? "content-expanded" : "content-collapsed"
        }`}
      >
        <MainHeader />
        <div className="px-3 mt-4">
          <div className="d-flex items-center justify-content-between mb-3">
            <h4 className="page-title d-flex justify-content-center mb-0">
              Resource Groups
            </h4>
            <div className="input-group w-25">
              <input
                type="text"
                placeholder="Search resource group ..."
                className="form-control"
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <div className="input-group-append">
                <span className="input-group-text h-100">
                  <SlMagnifier />
                </span>
              </div>
            </div>
          </div>
          {isLoading ? (
          <div className="d-flex justify-content-center my-4">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="accordion" id="resourceAccordion">
            {groupedResources?.length > 0 ?
              (groupedResources.map((group, index) => (
                <div className="accordion-item" key={group.id}>
                  <h2 className="accordion-header" id={`heading${group.id}`}>
                    <button
                      className={`accordion-button ${openAccordion === group.id ? "" : "collapsed"}`}
                      type="button"
                      onClick={() => toggleAccordion(group.id, group.resourceGroup)}
                      aria-expanded={openAccordion === group.id}
                      aria-controls={`collapse${group.id}`}
                    >
                      {group?.resourceGroupTags?.Name ? (
                        group.resourceGroupTags.Name
                      ) : (
                        <div>
                        <span className="text-muted">Tag-undefined</span> {' '}<span>({group?.resourceGroup})</span>
                        </div>
                      )}
                    </button>

                  </h2>
                  <div
                    id={`collapse${group.id}`}
                    className={`accordion-collapse collapse ${openAccordion === group.id ? "show" : ""
                      }`}
                    aria-labelledby={`heading${group.id}`}
                    data-bs-parent="#resourceAccordion"
                  >
                    <div className="accordion-body">
                      {filterDataByName.length > 0 ?


                        (
                          <div
                            className="accordion"
                            id={`resourcesAccordion${group.id}`}
                          >
                            <table className="table">
                              <thead className="tablebg">
                                <tr>
                                  <th
                                    scope="col"
                                    onClick={() => handleSort("name")}
                                    style={{ cursor: "pointer" }}
                                    className="text-uppercase tablebgtext border-top border-bottom "
                                  >
                                    Name
                                    {sortConfig.key === "name"
                                      ? sortConfig.direction === "asc"
                                        ? " ↑"
                                        : " ↓"
                                      : " ↑"}
                                  </th>
                                  <th
                                    scope="col"
                                    onClick={() => handleSort("type")}
                                    style={{ cursor: "pointer" }}
                                    className="text-uppercase tablebgtext border-top border-bottom "
                                  >
                                    Type
                                    {sortConfig.key === "type"
                                      ? sortConfig.direction === "asc"
                                        ? " ↑"
                                        : " ↓"
                                      : "↑"}
                                  </th>
                                  <th
                                    scope="col"
                                    onClick={() => handleSort("location")}
                                    style={{ cursor: "pointer" }}
                                    className="text-uppercase tablebgtext border-top border-bottom "
                                  >
                                    Location
                                    {sortConfig.key === "location"
                                      ? sortConfig.direction === "asc"
                                        ? " ↑"
                                        : " ↓"
                                      : " ↑"}
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-uppercase tablebgtext border-top border-bottom "
                                  >
                                    STATUS
                                  </th>
                                </tr>
                              </thead>
                              {sortedResources(filterDataByName).map(
                                (resource, resourceIndex) => {
                                  const running = resource?.state === "Running" || resource?.state === "PowerState/running";
                                  const stopped = resource?.state === "Stopped";
                                  const ready = resource?.state === "Ready";
                                  const deallocate = resource?.state === "Deallocated" || resource?.state === "PowerState/deallocated";
                                  const disabled = resource?.state === "Disabled";

                                  const badgeClass = running
                                    ? "text-success"
                                    : stopped
                                      ? "text-danger"
                                      : ready
                                        ? "text-warning"
                                        : deallocate
                                          ? "text-danger"
                                          : disabled
                                            ? "text-secondary"
                                            : "text-primary";
                                  return (
                                    <tbody key={resourceIndex}>
                                      <tr>
                                        <td className="border-0 fw-bold ps-2">
                                          {resource.name}
                                        </td>
                                        <td className="border-0">{resource.type}</td>
                                        <td className="border-0">
                                          {resource.location}
                                        </td>
                                        <td className="border-0">
                                          <div>
                                            <FaCircle
                                              className={`font-circle ${badgeClass}`}
                                            ></FaCircle>{" "}
                                            {resource?.state}
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  )
                                }
                              )}
                            </table>
                          </div>
                        ) : (
                          <p>No resources in this group.</p>
                        )}
                    </div>
                  </div>
                </div>
              ))) :
              <div className="d-flex justify-content-center my-4">
                <p>No resources group available.</p>
              </div>
            }
          </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default Inventory;
